// table utilities to work on different goodtable's

export default {
  computed: {
    emptyPlaceholder() {
      return `(${this.$t('common.none')})`;
    },
  },

  methods: {
    // fills unique list in the find combo boxes in vue-goodtable
    // hide combobox if unique list has less then 2 elements
    // field: should to be one fields of table.columns.field
    // use '(none)' for blank strings
    // ToDo: There is a new structure in version goodtable 2.2.0 !
    addFilterDropDownListByFieldWithAlgorithm(table, field, fieldExtractAlgorithm) {
      if (field === undefined || field === null) {
        // console.warn('mixins.table.addFilterDropDownListByField: field is not set');
        return;
      }
      if (typeof field !== 'string') {
        // console.warn('mixins.table.addFilterDropDownListByField: field is not a string');
        return;
      }
      if (table.rows === undefined || table.rows === null || table.columns === undefined || table.columns === null) {
        // console.warn
        // (`'mixins.table.addFilterDropDownListByField: undefined table structure for ${field}`);
        return;
      }

      const columnElement = table.columns.find(c => c.field === field);
      if (columnElement === undefined || columnElement === null) {
        // console.warn
        // (`'mixins.table.addFilterDropDownListByField: undefined columnElement for ${field}`);
        return;
      }

      columnElement.filterOptions = [
        ...new Set(
          table.rows // using Set for unique array list
            .filter(r => r[columnElement.field]) // ensure field exists
            .map(r => fieldExtractAlgorithm(r[columnElement.field])) // execute func on each entry
            .map(r => (r == null || r.trim() === '' ? this.emptyPlaceholder : r))
            .sort()
        ),
      ]; // sort
      columnElement.filterDropdown = true;
      columnElement.filterable = this.tableColumnShouldShowSearchDropDown(columnElement);
      columnElement.filter = this.tableColumnDropDownFilterFunction;
    },

    addFilterDropDownListByField(table, field) {
      this.addFilterDropDownListByFieldWithAlgorithm(table, field, this.tuaTransformFieldToString);
    },

    // The default filter searches for substrings. This is not desirable for drop down list filters.
    // Also handle '(none)' placeholder for blank strings
    tableColumnDropDownFilterFunction(data, filterString) {
      if (filterString === this.emptyPlaceholder) {
        return data == null || data.trim() === '';
      }
      return data === filterString;
    },

    tuaTransformFieldToString(field) {
      if (field === undefined || field === null) {
        return null;
      }
      return field.toString();
    },

    tuaTransformCutToFirstWord(field) {
      if (field === undefined || field === null) {
        return null;
      }
      let result = field.toString();
      const idx = result.indexOf(' ');
      if (idx > 0) {
        result = result.substring(0, idx);
      }
      return result;
    },

    tuaTransformCutToFirstBracket(field) {
      if (field === undefined || field === null) {
        return null;
      }
      let result = field.toString();
      const idx = result.indexOf('(');
      if (idx > 0) {
        result = result.substring(0, idx);
      }
      return result;
    },

    resetFilterDropDownListByField(table, field) {
      if (
        field === undefined ||
        field === null ||
        typeof field !== 'string' ||
        table.rows === undefined ||
        table.columns === undefined ||
        table.columns === null
      ) {
        return;
      }
      table.columns.forEach(columnElement => {
        if (columnElement.field === field) {
          columnElement.filterOptions = [];

          columnElement.filterable = false;
          columnElement.filterDropdown = false;
        }
      });
    },

    handleDefaultSearchFields(table) {
      if (table.rows !== undefined && table.columns !== undefined && table.columns !== null) {
        const shouldShowSearch = table.rows !== null && table.rows.length > 1;
        table.columns.forEach(columnElement => {
          if (
            columnElement.label !== 'common.action' && // don't search for button field
            columnElement.label.indexOf('.action') < 0 &&
            columnElement.ignoreOnHandleSearchFilter === undefined &&
            columnElement.ignoreOnHandleSearchFilter !== true
          ) {
            columnElement.placeholder = [];
            if (columnElement.filterable) {
              columnElement.filterable = shouldShowSearch;
            }
            if (shouldShowSearch === true) {
              if (this.tableColumnHasSearchDropDown(columnElement)) {
                if (columnElement.filterable) {
                  columnElement.filterable = this.tableColumnShouldShowSearchDropDown(columnElement);
                }
                if (columnElement.filterable === true) {
                  columnElement.placeholder = this.$t('common.filterPlaceholderDropDown');
                }
              } else {
                columnElement.placeholder = `${this.$t('common.filterPlaceholderSearch')} ${this.$t(columnElement.label)}`;
              }
            }
          }
        });
      }
    },

    shouldShowTablePageControlsByMinElements(table, minRowsLength) {
      // missing table or no v-bind/v-model
      if (table === undefined || table === null) {
        return true; // don't change the default!
      }
      // missing min or wrong type, set default
      if (minRowsLength === undefined || minRowsLength === null || typeof minRowsLength !== 'number') {
        minRowsLength = 10;
      }

      // the pagination page controls are the default style
      const shouldShowTablePageControls = table.rows !== undefined && table.rows !== null && table.rows.length >= minRowsLength;

      return shouldShowTablePageControls;
    },

    handleTablePageControlsByMinElements(table, minRowsLength) {
      // missing table or no v-bind
      if (table === undefined || table === null) {
        return;
      }
      table.paginate = this.shouldShowTablePageControlsByMinElements(table, minRowsLength);
    },

    // helper for internal use
    // ===============================
    // return 1 if table.columns element has a serach dropDown List
    tableColumnHasSearchDropDown(columnElement) {
      return columnElement.filterDropdown !== undefined && columnElement.filterDropdown === true;
    },

    // should be combined with hasSearchDropDown
    tableColumnShouldShowSearchDropDown(columnElement) {
      return columnElement.filterOptions !== undefined && columnElement.filterOptions !== null && columnElement.filterOptions.length > 1;
    },
  },
};
